import React, { PureComponent, Fragment } from "react";
import SelectItem from "react-select";
class SelectBox extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            item_default: [{ value: '', label: 'Todos' }], // Item default
            multiple: this.props.multiple || false, // Indica si es simple o seleccion múltiple
            placeholder: this.props.placeholder || "Cargando...", // Etiqueta Placeholder
            store: this.props.store || [], // Store data [label:,value:]
            nullable: this.props.nullable || true, // No permite seleccion vacia, por defecto selecciona el default
            item_all: this.props.item_all || false,
            item_selected: [{ value: '', label: 'Todos' }]
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange = event => {
        let me = this;
        if (event === null) {
            event = [];
        }
        let items = [];
        if (me.state.multiple) {
            if (event.length > 0) {
                event.map(function (item) {
                    if (me.state.item_all) {
                        if (item.value !== me.state.item_default[0].value) {
                            items.push(item);
                        }
                    } else {
                        items.push(item);
                    }
                });
            } else {
                if (this.state.nullable) {
                    items = me.state.item_default;
                }
            }
        } else {
            items = [event];
        }
        this.props.onChange(items);
    };
    render() {
        let item_selected = this.props.item_selected || [];
        return (
            <Fragment>
                <SelectItem
                    isMulti={this.props.multiple}
                    placeholder={this.state.placeholder}
                    onChange={this.handleChange}
                    value={item_selected.length !== 0 ? item_selected : this.state.item_default}
                    options={this.props.store}
                />
            </Fragment>
        );
    }
}

export default SelectBox;
